/**
 * <scent-picker>
 *
 * Enhancement for the Scent variant option (snippets/product-scent-picker.liquid).
 * Selection itself is native (<label> + radio) and is handled by the theme's
 * ProductForm engine; the "SCENT: <name>" header updates via the theme's
 * existing updateLegend. This element only swaps the "Smells like" description,
 * whose text lives on each radio's data-smells-like attribute because variant
 * metafields are not present in the product JSON.
 */
if (!customElements.get('scent-picker')) {
  class ScentPicker extends HTMLElement {
    connectedCallback() {
      this.description = this.querySelector('[data-scent-description]');
      this.descriptionWrap = this.querySelector('.scent-picker__smells-like');
      this._onChange = this.onChange.bind(this);
      this.addEventListener('change', this._onChange);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this._onChange);
    }

    onChange(event) {
      const input = event.target.closest('input[data-single-option-selector]');
      if (!input || !this.description) return;

      const smells = (input.dataset.smellsLike || '').trim();
      this.description.textContent = smells;
      if (this.descriptionWrap) this.descriptionWrap.hidden = smells === '';
    }
  }

  customElements.define('scent-picker', ScentPicker);
}
